import Pusher from 'pusher-js';

const PUSHER_APP_KEY = process.env.PUSHER_KEY;
const PUSHER_APP_CLUSTER = process.env.PUSHER_CLUSTER;

const PusherService = {
  pusher: undefined, // client instance

  getClientInstance() {
    if (!this.pusher) {
      this.pusher = new Pusher(PUSHER_APP_KEY, {
        cluster: PUSHER_APP_CLUSTER,
        enabledTransports: ['ws', 'wss', 'xhr_streaming'],
      });
    }

    return this.pusher;
  },
};

export default PusherService;
